import { useState } from 'react'
import { useInterval, useUpdateEffect } from 'ahooks'

/**
 * @param {object} opt
 * @param {boolean} opt.enabled 是否开始步进计时？
 * @param {number} opt.max 最大步进取值
 * @param {number} [opt.delay] 每次步进时延
 */
export function useTimingStep({ enabled, max = Infinity, delay = 200 }) {
  const [step, setStep] = useState(0)

  useUpdateEffect(() => {
    if (!enabled) {
      setStep(0)
    }
  }, [enabled])

  useInterval(
    () => {
      setStep(x => x + 1)
    },
    enabled && step < max ? delay : null,
  )

  return { step }
}
